import axios from '../axios'

// モジュールに項目（レッスン/クイズ）を配置
const postModuleItemApi = async (moduleId, payload) => {
  return await axios.post(`api/lms/modules/${moduleId}/items`, payload)
}

export default postModuleItemApi
